<template>
<!-- BEGIN SIDEBPANEL-->
<nav class="page-sidebar" data-pages="sidebar">
  <!-- BEGIN SIDEBAR MENU TOP TRAY CONTENT-->

  <!-- END SIDEBAR MENU TOP TRAY CONTENT-->
  <!-- BEGIN SIDEBAR MENU HEADER-->
  <div class="sidebar-header">      
    <div class="brand" v-html="brand"></div>
    <div class="sidebar-header-controls">          
    </div>
  </div>
  <!-- END SIDEBAR MENU HEADER-->
  <!-- START SIDEBAR MENU -->
  <div class="sidebar-menu">
    <!-- BEGIN SIDEBAR MENU ITEMS-->
    <ul class="menu-items">
      <slot></slot>          
    </ul>
    <div class="clearfix"></div>
  </div>
  <!-- END SIDEBAR MENU -->
</nav>
<!-- END SIDEBAR -->
<!-- END SIDEBPANEL-->
</template>

<script>
  import SidePanelItem from './side_panel_item.vue';
  import SidePanelCollection from './side_panel_collection.vue';

  export default {
    name: "SidePanel",
    props: {
      brand: {
        type: String,
        required: true
      }
    },
    components: {
      SidePanelCollection,
      SidePanelItem
    }
  }
</script>

<style>
  .page-sidebar {
    border-right: 1px solid #eaeaea !important;
  }
</style>


// WEBPACK FOOTER //
// side_panel.vue?0c22dafd